// src/api/authcertificados.js

// =============== Base de API robusta ===============
const API_BASE =
  (process.env.REACT_APP_API_URL &&
    process.env.REACT_APP_API_URL.replace(/\/+$/, '')) ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : window.location.origin);
    
// =============== Helpers de auth y request (ASUMIDO) ===============
function getStoredToken() {
  return (
    localStorage.getItem('token') ||
    localStorage.getItem('accessToken') ||
    sessionStorage.getItem('token') ||
    sessionStorage.getItem('accessToken') ||
    null
  );
}

function buildHeaders(userHeaders = {}) {
  const h = new Headers(userHeaders);
  if (!h.has('Accept')) h.set('Accept', 'application/json');
  const token = getStoredToken();
  if (token) {
    if (!h.has('Authorization')) h.set('Authorization', `Bearer ${token}`);
    if (!h.has('x-access-token')) h.set('x-access-token', token);
  }
  return h;
}

async function parseResponseOrThrow(res) {
  const url = res.url || '';
  const status = `${res.status} ${res.statusText}`.trim();
  const ct = (res.headers.get('content-type') || '').toLowerCase();
  const raw = await res.text();
  const isJson = ct.includes('application/json');

  if (!res.ok) {
    if (isJson) {
      let data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        throw new Error(`Error ${status}: JSON malformado de ${url}. Raw: ${raw.slice(0, 100)}`);
      }
      throw new Error(data.message || data.mensaje || `Error de API ${status} en ${url}`);
    } else {
      throw new Error(`Error de red ${status} en ${url}. Respuesta: ${raw.slice(0, 100)}`);
    }
  }

  if (isJson) {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {}; // Respuesta vacía o no JSON, pero OK.
    }
  }
  return raw;
}

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers: buildHeaders(options.headers),
  });
  return parseResponseOrThrow(res);
}
// =============== Fin Helpers de auth y request ===============


export async function getCertificados() {
  return request('/api/certificados/list');
}

// MODIFICACIÓN: createCertificado (recibe y envía el nuevo campo)
export async function createCertificado({ marca, modelo, creada, vence, observaciones, nom_identifier }, archivoPdf) {
  const fd = new FormData();
  fd.append('marca', marca);
  fd.append('modelo', modelo);
  fd.append('creada', creada);
  fd.append('vence', vence);
  fd.append('observaciones', observaciones);
  fd.append('nom_identifier', nom_identifier || ''); // <-- NUEVO CAMPO ENVIADO
  if (archivoPdf) fd.append('archivo', archivoPdf);
  return request('/api/certificados/create', { method: 'POST', body: fd });
}

// MODIFICACIÓN: updateCertificado (asegura que el nuevo campo se maneje)
export async function updateCertificado(id, datos = {}, archivoPdf = null) {
  // Cuando se sube un archivo (FormData)
  if (archivoPdf) {
    const fd = new FormData();
    fd.append('archivo', archivoPdf);
    Object.entries(datos || {}).forEach(([k, v]) => fd.append(k, v ?? ''));
    return request(`/api/certificados/update/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: fd,
    });
  }
  
  // Para JSON (edición inline o actualización sin archivo)
  return request(`/api/certificados/update/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(datos || {}),
  });
}

export async function deleteCertificado(id) {
  return request(`/api/certificados/delete/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}

export function getPdfUrl(filename) {
  return `${API_BASE}/api/certificados/pdf/${encodeURIComponent(filename)}`;
}

export async function descargarCertificadoPDF(filename, marca, modelo) {
  const url = getPdfUrl(filename);
  const res = await fetch(url, { credentials: 'include', headers: buildHeaders() });
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('application/pdf')) {
    await parseResponseOrThrow(res); // lanzará con detalle si no es PDF
  }
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = `Certificado_${marca}_${modelo}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
